<template>
    <div id="vehicleDataDetails">
        <div class="con">
            <img class="imgborder" src="../../assets/vehicleData/detailsBorder.png" alt="">
            <div class="details" v-loading="vehicleLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
                <div class="close" @click="close">
                    <img src="../../assets/vehicleData/close.png" alt="">
                </div>
                <div class="title">
                    <img src="../../assets/vehicleData/detailsLeft.png" alt="">
                    <span class="text">{{title}}</span>
                    <img src="../../assets/vehicleData/detailsRight.png" alt="">
                </div>
                <div class="line"><img src="../../assets/vehicleData/detailsLine.png" alt=""></div>
                <!-- <div class="details_content details_content2" v-if="details.type==4"> -->
                <div class="details_content details_content2" v-if="showTower==true">
                    <div class="content_top content_top2">
                        <div class="head_img">
                            <img class="border" src="../../assets/vehicleData/headBorder.png" alt="">
                            <img class="headerImg" :src="img" alt="">
                        </div>
                        <div class="head_text">
                            <div class="plateNo">{{details.name}}</div>
                            <div class="status">
                                <el-tooltip class="item item2" effect="light" placement="bottom" content="称重传感器正常">
                                    <img :src="towerUrl1" alt="">
                                </el-tooltip>
                                <el-tooltip class="item item2" effect="light" placement="bottom" content="进口监控正常">
                                    <img :src="towerUrl2" alt="" @click="monitorClick(1)">
                                </el-tooltip>
                                <el-tooltip class="item item2" effect="light" placement="bottom" content="出口监控正常" >
                                    <img :src="towerUrl3" alt="" @click="monitorClick(2)">
                                </el-tooltip>
                                <el-tooltip class="item item2" effect="light" placement="bottom" content="水分进口监测正常" >
                                    <img :src="towerUrl4" alt="">
                                </el-tooltip>
                                <el-tooltip class="item item2" effect="light" placement="bottom" content="水分出口监测正常" >
                                    <img :src="towerUrl5" alt="">
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                    <div class="content_cen content_cen2">
                        <div class="network" v-if="inNetwork==true">
                            <img  src="../../assets/vehicleData/inNetwork.png" alt="">
                        </div>
                        <div class="shield" v-if="details.insurance==true">
                            <img  src="../../assets/vehicleData/shield.png" alt="">
                        </div>
                        <div class="shield" v-else>
                            <el-tooltip class="item" effect="light" content="客服电话：15378900976" placement="bottom">
                                <img  src="../../assets/vehicleData/shield1.png" alt="">
                            </el-tooltip>
                        </div>
                        <div class="item">类型：<span>烘干作业</span></div>
                        <div class="item">位置：{{location}}</div>
                    </div>
                    <div class="content_bot content_bot2">
                        <div class="todayArea">
                            <div class="num">{{details.todayWeight}}</div>
                            <div class="text">今日重量（吨）</div>
                        </div>
                        <div class="allArea">
                            <div class="num">{{details.totalWeight}}</div>
                            <div class="text">总重量（吨）</div>
                        </div>
                    </div>
                </div>
                <div class="details_content" :class="{'details_content2':!inNetwork}" v-else>
                    <div class="content_top" :class="{'content_top2':!inNetwork}">
                        <div class="head_img">
                            <img class="border" src="../../assets/vehicleData/headBorder.png" alt="">
                            <img class="headerImg" :src="img" alt="">
                        </div>
                        <div class="head_text">
                            <div class="plateNo">{{details.plateNo}}</div>
                            <div class="status" v-if="inNetwork">
                                <el-tooltip class="item" effect="light" placement="bottom" :content="details.cameraType">
                                    <img :src="cameraUrl" alt="">
                                </el-tooltip>
                                <el-tooltip class="item" effect="light" placement="bottom" :content="details.ploughType">
                                    <img :src="ploughUrl" alt="">
                                </el-tooltip>
                                <el-tooltip class="item" effect="light" placement="bottom" :content="details.positioningType" >
                                    <img :src="positioningUrl" alt="">
                                </el-tooltip>
                            </div>
                        </div>
                    </div>
                    <div class="content_cen">
                        <div class="network" v-if="inNetwork==true">
                            <el-tooltip class="item" effect="light" content="已在网" placement="bottom">
                                <img  src="../../assets/vehicleData/inNetwork.png" alt="">
                            </el-tooltip>
                        </div>
                        <div class="network" v-else>
                            <el-tooltip class="item" effect="light" content="不在网" placement="bottom">
                                <img  src="../../assets/vehicleData/inNetwork1.png" alt="">
                            </el-tooltip>
                        </div>
                        <div class="shield" v-if="details.insurance==true" @click="roPolicyDetail()">
                            <img  src="../../assets/vehicleData/shield.png" alt="">
                        </div>
                        <div class="shield" v-else>
                            <el-tooltip class="item" effect="light" content="客服电话：15378900976" placement="bottom">
                                <img  src="../../assets/vehicleData/shield1.png" alt="">
                            </el-tooltip>
                        </div>
                        <div class="item">车主姓名：{{details.driverName}}</div>
                        <div class="item">车主电话：{{details.driverPhone}}</div>
                        <div class="item">车辆动力：{{details.horsePower}}马力</div>
                        <div class="item">年审时间：{{details.annualReviewTime}}</div>
                        <div class="item" style="letter-spacing: 4.3px" v-if="details.driverLicense==null||details.driverLicense==''">行驶证：<span >无</span></div>
                        <div class="item" style="letter-spacing: 4.3px" v-else>行驶证：<span style="color: #669DFF;cursor: pointer;" @click="checkLicense(details.driverLicense)">查看</span></div>
                        <div class="item" v-if="inNetwork">作业类型：
                            <span v-for="(item,index) in details.list" :key="index">
                                <el-tooltip class="item" effect="light" placement="bottom" :content="details.currentModule" >
                                    <div slot="content">主机id：{{details.simNo}}<br/>犁具id：{{item.simIdPlough}}<br/>幅宽：{{item.equipmentWidth}}米</div>
                                    <span v-if="item.current==1" class="onUse">
                                        {{item.module}}
                                    </span>
                                    <span v-if="item.current==0" class="noUse">
                                        {{item.module}}
                                    </span>
                                </el-tooltip>
                            </span>
                        </div>
                        <div class="item" v-if="inNetwork">定位时间：{{details.sendTime}}</div>
                        <div class="item" v-if="inNetwork">车辆位置：{{location}}</div>
                    </div>
                    <div class="content_bot" v-if="inNetwork">
                        <div class="todayArea">
                            <div class="num">{{details.todayArea}}</div>
                            <div class="text">今日作业面积(亩)</div>
                        </div>
                        <div class="allArea">
                            <div class="num">{{details.totalArea}}</div>
                            <div class="text">全部作业面积(亩)</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import eventBus from '@/eventBus.js';
import T from 'T'
import {gettime} from '../../js/gettime.js';
import WitVehicleStatisticsService from '../../services/jaxrs/concrete/com.zny.eop.witAgriculture.api.WitVehicleStatisticsService.js';
import VehicleDataService from '../../services/jaxrs/concrete/com.zny.eop.platform.api.VehicleDataService.js';
export default {
    data(){
        return{
            showTower:false,//true：显示烘干塔false：显示车辆
            title:'',
            vehicleId:"",//车辆id
            details:{},
            location:'',
            inNetwork:true,
            vehicleLoading:true,
            img:require('../../assets/vehicleData/header1_1.png'),
            cameraUrl:require('../../assets/vehicleData/cameraNotOnline.png'),
            ploughUrl:require('../../assets/vehicleData/ploughNotOnline.png'),
            positioningUrl:require('../../assets/vehicleData/positioningNotOnline.png'),
            towerUrl1:require('../../assets/vehicleData/towerOnline1.png'),//烘干塔称重传感器
            towerUrl2:require('../../assets/vehicleData/towerOnline2.png'),//烘干塔进口监控
            towerUrl3:require('../../assets/vehicleData/towerOnline3.png'),//烘干塔出口监控
            towerUrl4:require('../../assets/vehicleData/towerOnline4.png'),//烘干塔进口湿度检测
            towerUrl5:require('../../assets/vehicleData/towerOnline5.png'),//烘干塔出口湿度检测
        }
    },
    mounted(){
        this.checkCar();
    },
    methods:{

        // 摄像头点击
        monitorClick(num){
            var that=this
            that.$nextTick(function () {
                //地图平移
                setTimeout(function(){
                    eventBus.$emit('realVideoShow',that.details.simNo,num)
                },500)
            })
        },
        //点击车辆
        checkCar(){
            var that=this
            eventBus.$off("check");
            eventBus.$on('check',function(vehicleId,num,type){//num:1:列表车辆树点击,2:地图marker点击 type:4烘干塔
                // console.log(vehicleId,num)
                that.vehicleLoading=true
                that.vehicleId=vehicleId
                if(type==4){
                    that.title='烘干塔信息'
                    that.showTower=true
                    that.forTowerDetails()
                }else{
                    that.title='农机数据'
                    that.showTower=false
                    that.forDetails()
                }
            })
        },
        // 查烘干塔详情
        forTowerDetails(){
            this.vehicleLoading=false
            var time=gettime.forTime()
            var details={
                id:this.vehicleId,
                startTime:time.start,
                endTime:time.end
            }
            VehicleDataService.findDryingTowerDetails(details)
            .then((res)=>{
                this.details=res
                this.img=require('../../assets/vehicleData/header6_0.png')
                this.vehicleLoading=false
                if(res.longitude==0||res.longitude==null||res.longitude==undefined||res.latitude==0||res.latitude==null||res.latitude==undefined){
                    return
                }else{
                    var lnglat=new T.LngLat(res.longitude, res.latitude)
                    this.getLoaction(lnglat)
                }
            })
            .catch((err)=>{
                this.vehicleLoading=false
            })
        },
        //查车辆详情
        forDetails(){
            WitVehicleStatisticsService.findVehicleDetails(this.vehicleId,this.$store.state.time)
            .then((res)=>{
                // console.log(res)
                var that=this
                that.vehicleLoading=false
                // if(res.type==4){
                //     that.title='烘干塔信息'
                // }else{
                //     that.title='农机数据'
                // }
                if(res.inNetwork){
                    that.inNetwork=true
                }else{
                    that.inNetwork=false
                }
                // if(res.vehicleType==4 || !res.inNetwork){
                //     that.$nextTick(function () {
                //         $('#home_details').addClass('home-details')
                //     })
                // }else{
                //     that.$nextTick(function () {
                //         $('#home_details').removeClass('home-details')
                //     })
                // }
                if(res){
                    if(res.list.length>0){
                        var arr=[]
                        for(var i=0;i<res.list.length;i++){
                            if(res.list[i].current==1){
                                arr.unshift(res.list[i])
                            }else{
                                arr.push(res.list[i])
                            }
                        }
                        res.list=arr
                    }
                    if(res.online==true){
                        if(res.lat==0||res.lat==null||res.lng==null||res.lng==0){
                            that.$message.error('车辆不定位');
                        }else{
                            // landTreatment.mapTranslation(that,res)
                        }
                    }else{
                        if(res.lat==0||res.lat==null||res.lng==null||res.lng==0){
                            // that.$message.error('车辆不定位');
                            // console.log(1)
                        }else{
                            // landTreatment.mapTranslation(that,data)
                        }
                    }
                    var positioningType=''//定位
                    var cameraType=''//摄像头
                    var ploughType=''//犁具
                    // var OnlineStatus=0//在线状态1：在线；2：报警；3：离线
                    if(res.online==true){
                        if(res.status&&res.alarmState){
                            var status=res.alarmState+res.status
                            var snumber=63
                            if( !isNaN(status) ){
                                // if(res.haveCamera==1){
                                //     if( status.substr((snumber - 1),1)==0 || res.simIdPlough=='000000000000' || res.simIdPlough=='000000111111' || status.substr((snumber - 43),1)==1){
                                //         OnlineStatus=2
                                        
                                //     }else{
                                //         OnlineStatus=1
                                //     }
                                // }else if(res.haveCamera==0){
                                //     if( status.substr((snumber - 1),1)==0 || res.simIdPlough=='000000000000' || res.simIdPlough=='000000111111'){
                                //         OnlineStatus=2
                                        
                                //     }else{
                                //         OnlineStatus=1
                                //     }
                                // }
                                // 定位报警数组
                                if( status.substr((snumber - 1),1)==0 ){
                                    that.positioningUrl=require('../../assets/vehicleData/positioningAlarm.png')
                                    positioningType='定位报警'
                                }else{
                                    that.positioningUrl=require('../../assets/vehicleData/positioning.png')
                                    positioningType='定位正常'
                                }
                                // 摄像头报警数组
                                if( status.substr((snumber - 43),1)==1 && res.haveCamera==1){
                                    that.cameraUrl=require('../../assets/vehicleData/cameraAlarm.png')
                                    cameraType='摄像头报警'
                                }else{
                                    that.cameraUrl=require('../../assets/vehicleData/camera.png')
                                    cameraType='摄像头正常'
                                }
                                // 犁具报警数组
                                if( res.simIdPlough=='000000000000' || res.simIdPlough=='000000111111' ){
                                    that.ploughUrl=require('../../assets/vehicleData/ploughAlarm.png')
                                    ploughType='犁具报警'
                                }else{
                                    that.ploughUrl=require('../../assets/vehicleData/plough.png')
                                    ploughType='犁具正常'
                                }
                            }
                        }else{
                            // alarmType.push("正常")
                            // OnlineStatus=3
                        }
                    }else{
                        // alarmType.push("正常")
                        // OnlineStatus=3
                        that.positioningUrl=require('../../assets/vehicleData/positioningNotOnline.png')
                        that.cameraUrl=require('../../assets/vehicleData/cameraNotOnline.png')
                        that.ploughUrl=require('../../assets/vehicleData/ploughNotOnline.png')
                        positioningType='定位正常'
                        cameraType='摄像头正常'
                        ploughType='犁具正常'
                    }
                    // var Status=0
                    // if(OnlineStatus==2){
                    //     Status=1
                    // }else{
                    //     Status=OnlineStatus
                    // }
                    var state=0
                    if(res.online==true){
                        state=1
                    }else{
                        state=0
                    }
                    // console.log(res.type)
                    if(res.type==2){//收获机
                        that.img=require('../../assets/vehicleData/header2_'+state+'.png')
                    }else if(res.type==3){//植保
                        if(res.littleType==11){//飞防
                            that.img=require('../../assets/vehicleData/header3_'+state+'.png')
                        }else if(res.littleType==10){//自走式
                            that.img=require('../../assets/vehicleData/header4_'+state+'.png')
                        }
                    }else if(res.type==4){//烘干塔
                        that.img=require('../../assets/vehicleData/header6_0.png')
                    }else if(res.type==12){//运输车
                        that.img=require('../../assets/vehicleData/header5_'+state+'.png')
                    }else{//其他类型以及拖拉机
                        that.img=require('../../assets/vehicleData/header1_'+state+'.png')
                    }
                    res.positioningType=positioningType
                    res.cameraType=cameraType
                    res.ploughType=ploughType
                    // res.OnlineStatus=OnlineStatus
                    that.details=res
                }
                if(res.lng==0||res.lng==null||res.lng==undefined||res.lat==0||res.lat==null||res.lat==undefined){
                    return
                }else{
                    var lnglat=new T.LngLat(res.lng, res.lat)
                    that.getLoaction(lnglat)
                }
            })
            .catch(err=>{
                var that = this
                that.vehicleLoading=false
            })
        },
        //反地理位置解析
        getLoaction(lnglat){
            var that = this
            //创建对象
            var geocode = new T.Geocoder();
            geocode.getLocation(lnglat,searchResult);
            function searchResult(result)
            {
                if(result.getStatus() == 0) {
                    that.location=result.getAddress();
                }
            }
        },
        //查看行驶证
        checkLicense(license){
            var that = this
            that.$store.state.camera='license'
            setTimeout(function () {
                eventBus.$emit('toLicense',license)
            },500)
        },
        //查看保单
        roPolicyDetail(){
            const { href } = this.$router.resolve({
                path: "/policy",
                query: {
                    id: this.details.id
                }
            });
            window.open(href, '_blank');
        },
        close(){
            this.$store.state.details=''
        },
    },
    beforeDestroy() {
        var that = this
        that.$store.state.camera=''
    }
}
</script>
<style lang="less">
@import '../../viewsStyle/vehicleData/vehicleDataDetails.less';
@media screen and (max-width: 1280px){
    #vehicleDataDetails{
        .con{
            .details{
                .title{
                    padding: 5% 0 0 0;
                }
            }
        }
    }
}
</style>